import { Predicate, SortOption } from "../../core/storage/predicate";
import { FetchRequest } from "../../core/storage/fetch-request";
import { Equipment } from "../equipment.model";

export class FetchChildrenEquipmentsRequest implements FetchRequest<Equipment> {
  readonly predicates: Predicate<Equipment>[] | null = null;
  readonly sortDescriptors: SortOption<Equipment>[] | null = null;
  readonly parentAssetItemNumber: number;

  constructor(parentAssetItemNumber: number) {
    this.parentAssetItemNumber = parentAssetItemNumber;

    if (this.parentAssetItemNumber) {
      this.predicates = [new Predicate<Equipment>().whereEq("parentAssetItemNumber", this.parentAssetItemNumber)];
    }
    this.sortDescriptors = [{ field: "unitNumber", direction: "asc" }];
  }
}

export function fetchChildrenEquipmentsRequest(parentAssetItemNumber: number): FetchChildrenEquipmentsRequest {
  return new FetchChildrenEquipmentsRequest(parentAssetItemNumber);
}
